var React = require('react');

function IcConsole (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M0,0V32H32V0ZM30.667,21.333A2.675,2.675,0,0,1,28,24H4a2.675,2.675,0,0,1-2.667-2.667V10.667A2.675,2.675,0,0,1,4,8H28a2.675,2.675,0,0,1,2.667,2.667Z","key":0}),React.createElement("path",{"fill":"currentColor","d":"M28.333,2H1.667A2.675,2.675,0,0,0-1,4.667v16a2.675,2.675,0,0,0,2.667,2.667H28.333A2.675,2.675,0,0,0,31,20.667v-16A2.675,2.675,0,0,0,28.333,2ZM13,14H9v4H6.333V14h-4V11.333h4v-4H9v4h4Zm7.333,2.667a2,2,0,1,1,2-2A2,2,0,0,1,20.333,16.667Zm5.333-4a2,2,0,1,1,2-2A2,2,0,0,1,25.667,12.667Z","transform":"translate(1 3.333)","key":1})]);
}

IcConsole.defaultProps = {"id":"ic-console","viewBox":"0 0 32 32"};

module.exports = IcConsole;

IcConsole.default = IcConsole;
